<template>
  <v-dialog v-model="openModal" width="65vw">
    <v-card
      class="card-container"
      :class="{ 'no-padding': noDefaultPadding }"
      style="height: 90vh"
    >
      <div>
        <v-toolbar
          elevation="0"
          color="background"
          class="fluid-toolbar"
          :class="{
            'no-x-padding': !noDefaultPadding,
            small: smallToolbarPadding,
            'mb-6': !smallToolbarPadding,
          }"
        >
          <v-toolbar-title
            class="text-h6 font-weight-medium mt-2"
            :class="{
              'small-title': smallToolbarPadding,
              'brand--text text--darken-2': !$vuetify.theme.dark,
            }"
          >
            {{ $t('message.ai.mindmap.mindmap') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="align-self-baseline">
            <v-btn icon @click="handleCloseModal" class="no-ripple">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <MindmapEditor :videoId="videoId" />
      </div>
      <v-card-actions
        class="justify-center px-0"
        style="position: absolute; bottom: 4%; width: calc(100% - 64px)"
      >
        <BaseBtn
          id="discardChanges"
          @click="handleDiscardChanges"
          type="secondary"
          >{{ $t('message.pages.video.discardChanges') }}</BaseBtn
        >
        <v-spacer></v-spacer>
        <BaseBtn
          id="saveButton"
          @click="saveEditedMindmap"
          :loading="loadingSaveButton"
          >{{ $t('message.pages.video.save') }}</BaseBtn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import MindmapEditor from '@/components/MindmapEditor.vue'
export default {
  name: 'MindmapEditModal',
  components: { BaseBtn, MindmapEditor },
  data: () => ({
    openModal: false,
    mermaidScriptLoaded: false,
    mermaid: '',
    mermaidDiagram: '',
    componentKey: 1,
    themeChanged: false,
    loadingSaveButton: false,
  }),
  props: {
    noDefaultPadding: {
      type: Boolean,
      default: false,
    },
    smallToolbarPadding: {
      type: Boolean,
      default: false,
    },
    videoId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.$root.$on('openEditMindMapModal', async () => {
      this.handleOpenModal()
    })
    this.$root.$on('loadingSaveButton', (val) => {
      this.loadingSaveButton = val
      if (!val) {
        this.handleCloseModal()
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('openEditMindMapModal')
    this.$root.$off('loadingSaveButton')
  },
  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.dark
    },
  },
  watch: {
    isDarkTheme: {
      handler() {
        this.themeChanged = true
      },
    },
  },
  methods: {
    handleOpenModal() {
      this.openModal = true
      if (this.themeChanged) {
        this.$root.$emit('updateDiagramTheme')
      }
      this.themeChanged = false
    },
    handleCloseModal() {
      this.openModal = false
    },
    saveEditedMindmap() {
      this.$root.$emit('saveEditedMindmap')
    },
    handleDiscardChanges() {
      this.$root.$emit('handleDiscardChanges')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';
</style>

<style lang="scss">
.not-allowed {
  cursor: not-allowed !important;
}
.no-x-padding {
  .v-toolbar__content {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.fluid-toolbar {
  height: unset !important;
  .v-toolbar__content {
    height: unset !important;
  }

  &.small {
    height: unset !important;

    .v-toolbar__content {
      height: unset !important;
      padding: 16px 24px 24px 24px;
    }
  }
  &:not(.small) {
    .v-toolbar__content {
      padding: 24px 32px 0px 32px;
    }
  }
}

.v-application .small-title.text-h6 {
  font-size: 18px !important;
}
</style>

<style lang="scss" scoped>
.card-container {
  max-height: 90vh;
  > div {
    max-height: inherit;
  }
  ::v-deep * {
    font-family: Rubik !important;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .v-toolbar__content,
  .v-toolbar__items,
  .v-toolbar__items > button {
    height: unset !important;
    width: auto !important;
  }

  &:not(.no-padding) {
    padding: 0px 32px 0px 32px !important;
  }
}
.v-btn.no-ripple::before {
  display: none;
}
</style>
